import UserActivity from './UserActivity';

export default UserActivity;